import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import { extendObservable } from 'mobx'
import styled, { keyframes } from 'styled-components'
import PlayItemUnresolved from '@/Components/CommandHost/PlayItemUnresolved'
import { vhToPx } from '@/utils'
import PrePickItem from '@/Components/CommandHost/PrePickItem'
import { responsiveDimension } from '../../utils'

@inject('GameStore')
@observer
export default class PrePicksPanel extends Component {
  render() {
    let { GameStore } = this.props

    return (
      <Container
        className="pre_pick_container"
        key={`prepickspanel-${GameStore.prePickUpdateCounter}`}
      >
        <Wrapper>
          <TitleContainer id="pre_picks_header">{'PRE-PICKS'}</TitleContainer>
          {(GameStore.prePicks || []).map(pp => {
            if (
              typeof pp.choices === 'string' ||
              !GameStore.prePickUpdateCounter
            )
              return ''
            return (
              <PrePickItem
                key={`prepick-item-${pp.prePickId}-${GameStore.prePickUpdateCounter}`}
                item={pp}
              />
            )
          })}
        </Wrapper>
      </Container>
    )
  }
}

const Container = styled.div`
  width: 100%;
  display: flex;
  background-color: #eaeaea;
  position: relative;
`

const Wrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: ${props => 5}vh;
  margin-bottom: ${props => 5}vh;
`

const TitleContainer = styled.div`
  width: 100%;
  height: ${responsiveDimension(2.6)};
  display: flex;
  justify-content: center;
  font-family: pamainbold;
  font-size: ${responsiveDimension(2)};
  color: #808285;
  letter-spacing: 2px;
  transform: scaleX(1.5);
`



// WEBPACK FOOTER //
// src/Components/CommandHost/PrePicksPanel.js